// 4-phase grouping mirrors Boris's DesktopFrame side-rail (reg-app-dt.jsx phaseOf()).
// Visual only — does not affect routing/flow.
export const PHASE_LABEL_KEYS = [
  'reg-phase.details',
  'reg-phase.screening',
  'reg-phase.eligibility',
  'reg-phase.app',
] as const;

const ROUTE_PHASE: Record<string, number> = {
  '/medicare-coverage': 0,
  '/health-conditions': 1,
  '/ckm-conditions': 1,
  '/behavioral-health-conditions': 1,
  '/phq9-screener': 1,
  '/gad7-screener': 1,
  '/eligibility-result': 2,
  '/track-offering': 2,
  '/not-eligible': 2,
  '/create-account': 2,
  '/shipping': 3,
  '/download-app': 3,
  '/check-sms': 3,
  '/download-app-qr': 3,
};

export const phaseForRoute = (pathname: string): number =>
  pathname in ROUTE_PHASE ? ROUTE_PHASE[pathname] : -1;
